import React from "react";
import OTPInput from "otp-input-react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Snackbar } from "../../utils/snackbar";
import { otpverify } from "../../services/Authservice";

const OTPverify = () => {
  const navigate = useNavigate();
  const [otp, setotp] = useState(Number);
  const [open, setOpen] = useState(false);
  const [error, seterror] = useState(false);
  const [loading, setloading] = React.useState(false);
  const [otperror, setotperror] = useState(false);
  const location = useLocation();
  const email = location.state.email;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  const handleverify = async () => {
    if (otp.length === 0) {
      setotperror("Required");
    } else if (otp.length !== 6) {
      setotperror("OTP must be 6 Characters");
    } else {
      setotperror("");
      setloading(true);
      try {
        const data = await otpverify(otp, email);
        navigate("/ResetPassword", {
          state: {
            email: email,
          },
        });
        setloading(false);
      } catch (error) {
        seterror(error.message);
        setOpen(true);
        setloading(false);
      }
    }
  };
  return (
    <>
      <div className="App">
        <div className="Auth-form-container1">
          <div className="Auth-form1">
            <div className="Auth-form-content1">
              <h3 className="Auth-form-title">Verify OTP</h3>

              <OTPInput
                value={otp}
                onChange={(e) => {
                  setotp(e);
                  setotperror("");
                }}
                className="otp_field"
                OTPLength={6}
                otpType="number"
                disabled={false}
                inputStyles={{
                  borderRadius: 10,
                  outline: 0,
                  border: "0.5px solid rgb(130, 130, 130)",
                  padding: "10px 8px",
                  marginRight: 10,
                  color: "var(--blurwhite)",
                  backgroundColor: "transparent",
                  boxShadow: "0px 0px 30px 0px #00000012",
                  fontSize: "18px",
                }}
                resendOTP={{}}
                //  secure
              />

              {/* <ResendOTP
                renderTime={() => React.Fragment}
                renderButton={(buttonProps) => {
                  return (
                    <Button
                      {...buttonProps}
                      style={{ margin: "auto", color: "#7A7AB1" }}
                    >
                      {buttonProps.remainingTime !== 0
                        ? `Please wait for ${buttonProps.remainingTime} sec`
                        : "Resend"}
                    </Button>
                  );
                }}
              /> */}
              <button
                type="submit"
                className="btn-14"
                disabled={loading}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                onClick={handleverify}
                // onClick={() => navigate("/ResetPassword")}
              >
                {loading ? "Loading...." : "Submit"}
              </button>
            </div>
          </div>
        </div>
        <Snackbar
          open={open}
          severity="error"
          onclose={handleClose}
          message={error}
        />
      </div>
    </>
  );
};
export default OTPverify;
